import {
    post
} from './request'

// 轮播新闻动态接口
export const getNewsBanner = data => post('/index/recom_list', data)
// 新闻动态列表接口
// export const getNewsListAndCategory = data => post('/index/news_cate_list', data)
// 新闻动态分类列表接口 
export const getNewsCategoryList = data => post('/index/cate_list', data)
// 新闻动态二级类目下新闻列表接口
export const getNewsByCategoryId = data => post('/index/cate_news_list', data)
export const getNewsOne = data => post('/index/news_detail', data)
// 
export const getNewsBySearch = data => post('/index/search', data)
export const getOneBySearch = data => post('/index/search_detail', data)

export const get_news_list = data => post('/index/news_list', data)